import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BrowserAgentService } from '../../services/browser-agent.service';
import { LoggingService, LogLevel } from '@app/services/logging.service';

@Component({
    selector: 'app-push-notification-prompt',
    templateUrl: './push-notification-prompt.component.html',
    styleUrl: './push-notification-prompt.component.scss',
    standalone: false
})
export class PushNotificationPromptComponent {
  static readonly COMPONENT_NAME = 'PushNotificationPromptComponent';


  browser = 'Unknown';
  platform = 'Unknown';
  isPwaMode = false;

  constructor(
    public dialogRef: MatDialogRef<PushNotificationPromptComponent>,
    public browserAgentService: BrowserAgentService,
    private loggingService: LoggingService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.loggingService.log(LogLevel.DEBUG, PushNotificationPromptComponent.COMPONENT_NAME, 'Dialog Data:', data);
    this.dialogRef.addPanelClass(['push-notification-prompt']);
  }

  ngOnInit() {
    this.loggingService.log(LogLevel.DEBUG, PushNotificationPromptComponent.COMPONENT_NAME, "ngOnInit Push Notification Prompt Dialog:", this.data);
    (async () => {
      const userAgent = await this.browserAgentService.getBrowserUserAgent();
      const detectedSystemData = this.detectBrowserAndPlatform(userAgent);
      this.browser = detectedSystemData.browser;
      this.platform = detectedSystemData.platform;
      this.loggingService.log(LogLevel.DEBUG, PushNotificationPromptComponent.COMPONENT_NAME, "Browser:", this.browser);
      this.loggingService.log(LogLevel.DEBUG, PushNotificationPromptComponent.COMPONENT_NAME, "platform:", this.platform);


      // this.platform = 'ios';
      // this.platform = 'mac';
    })();
  }


  getPWADisplayMode() {
    let navigator: any = window.navigator as any;
    const mediaQueryList = window.matchMedia('(display-mode: standalone)');
    this.isPwaMode = mediaQueryList.matches || navigator?.standalone;
  }


  detectBrowserAndPlatform(userAgent: any) {
    const regex = {
      chrome: /Chrome|CriOS\/(\d+)/,
      edge: /Edg\/(\d+)/,
      firefox: /Firefox\/(\d+)/,
      opera: /OPR\/(\d+)/,
      safari: /Version\/(\d+)/,
      windows: /Windows NT (\d+)/,
      mac: /Macintosh; Intel Mac OS X (\d+[_.]\d+[_.]\d+)/,
      linux: /Linux/,
      ios: /(iPhone|iPad|iPod)/,
    };

    const browser = {
      chrome: userAgent.match(regex.chrome),
      edge: userAgent.match(regex.edge),
      firefox: userAgent.match(regex.firefox),
      opera: userAgent.match(regex.opera),
      safari: userAgent.match(regex.safari),
    };

    const platform = {
      windows: userAgent.match(regex.windows),
      mac: userAgent.match(regex.mac),
      linux: userAgent.match(regex.linux),
      ios: userAgent.match(regex.ios),
    };

    let detectedBrowser = '';
    let detectedPlatform = '';

    for (const [key, value] of Object.entries(browser)) {
      if (value !== null) {
        detectedBrowser = key;
        break;
      }
    }

    for (const [key, value] of Object.entries(platform)) {
      if (value !== null) {
        detectedPlatform = key;
        break;
      }
    }

    return {
      browser: detectedBrowser,
      platform: detectedPlatform,
    };
  }

  confirmClick() {
    this.data.isConfirmed = true;
    this.dialogRef.close(this.data);
  }
}
